module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00031-fs8.d03fbb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00031-fs8.png
// module id = 184
// module chunks = 0